<template>
  <v-flex sm12 md6>
    <v-card class="card-wrapper" :height="'100%'" tile>
      <ul class="lang">
        <li v-for="lang in langList" :key="lang">
          <v-btn small
            :dark="getCurrentLang === lang"
            :class="{'purple': getCurrentLang === lang}"
            @click="changeLang(lang)">{{lang === 'uk' ? 'ua' : lang }}</v-btn>
        </li>
      </ul>
      <v-icon @click="change = !change" class="edit-card" color="purple">settings</v-icon>
      <v-icon @click="logout" class="logout" color="purple">exit_to_app</v-icon>
      <v-card-text v-if="change" class="text-xs-center">
        <v-avatar @mouseover="mouseOver" @mouseleave="mouseLeave" :size="100">
          <img :src="logo" alt="avatar">
          <v-icon v-show="changeLogo" class="edit-logo" @click="$refs.fileInput.click()">edit</v-icon>
        </v-avatar>
        <p class="font-weight-bold title">{{firstName}} {{lastName}}</p>
        <span class="font-weight-bold subheading">{{email}}</span>
        <br>
        <input type="file" ref="fileInput" @change="updateImg" style="display: none">
      </v-card-text>
      <v-card-text v-else>
        <v-expansion-panel v-model="panel">
          <v-expansion-panel-content>
            <div slot="header">{{$t('EDIT YOUR NAME')}}</div>
            <v-form
              class="change-form"
              @submit.prevent="validateForm('edit-name')"
              data-vv-scope="edit-name"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      required
                      color="purple"
                      v-validate="'required|max:10'"
                      :label="$t('Enter your new name')"
                      data-vv-name="firstName"
                      class="add-margin"
                      v-model="newFirstName"
                      :counter="10"
                      :error-messages="errors.collect('firstName')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      required
                      color="purple"
                      v-validate="'required'"
                      :label="$t('Enter your new lastname')"
                      data-vv-name="lastName"
                      class="add-margin"
                      v-model="newLastName"
                      :error-messages="errors.collect('lastName')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn class="add-margin" type="submit" dark color="purple" block>{{$t('save')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="!isGoogleAuth">
            <div slot="header">{{$t('Password')}}</div>
            <v-form
              class="change-form"
              @submit.prevent="validateForm('edit-password')"
              data-vv-scope="edit-password"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      class="custom-append add-margin"
                      color="purple"
                      ref="newPassword"
                      name="newPassword"
                      :label="$t('New password')"
                      data-vv-name="newPassword"
                      data-vv-delay="300"
                      min="8"
                      v-validate="'required|min:8'"
                      :placeholder="$t('Enter your password')"
                      v-model="newPassword"
                      :type="isPasswordVisible ? 'text' : 'password'"
                      :error-messages="errors.collect('password')"
                    >
                      <template slot="append">
                        <div @click="changeVal('isPasswordVisible')">
                          <span v-if="!isPasswordVisible">{{$t('Show')}}</span>
                          <span v-else>{{$t('Hide')}}</span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      v-model="passwordCurrent"
                      class="custom-append add-margin"
                      color="purple"
                      :label="$t('Current password')"
                      data-vv-name="passwordCurrent"
                      data-vv-delay="300"
                      target="password"
                      min="8"
                      v-validate="'required|min:8'"
                      :error-messages="errors.collect('password')"
                      :type="isPasswordVisible2 ? 'text' : 'password'"
                      :placeholder="$t('Enter confirm password')"
                    >
                      <template slot="append">
                        <div @click="changeVal('isPasswordVisible2')">
                          <span v-if="!isPasswordVisible2">{{$t('Show')}}</span>
                          <span v-else>{{$t('Hide')}}</span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn class="add-margin" type="submit" dark color="purple" block>{{$t('save')}}</v-btn>
                  </v-flex>
                  <v-flex xs12>
                    {{$t('Don’t you remember your current password?')}}
                    <a
                      href="#"
                      @click.prevent="reset"
                    >{{$t('Reset your password via email')}}</a>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-expansion-panel-content>
          <v-expansion-panel-content>
            <div slot="header">{{$t('EMAIL')}}</div>
            <v-form
              class="change-form"
              @submit.prevent="validateForm('edit-email')"
              data-vv-scope="edit-email"
              v-if="!isGoogleAuth"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      required
                      v-model="newEmail"
                      class="add-margin"
                      color="purple"
                      v-validate="'required|email'"
                      :label="$t('New email')"
                      data-vv-name="email"
                      :placeholder="$t('Enter your email')"
                      :error-messages="errors.collect('email')"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      class="custom-append add-margin"
                      color="purple"
                      ref="password"
                      name="password"
                      :label="$t('Current password')"
                      data-vv-name="password"
                      data-vv-delay="300"
                      min="8"
                      v-validate="'required|min:8'"
                      :placeholder="$t('Enter your password')"
                      v-model="emailPass"
                      :error-messages="errors.collect('password')"
                      :type="isPasswordVisible ? 'text' : 'password'"
                    >
                      <template slot="append">
                        <div @click="changeVal('isPasswordVisible')">
                          <span v-if="!isPasswordVisible">{{$t('Show')}}</span>
                          <span v-else>{{$t('Hide')}}</span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn class="add-margin" type="submit" dark color="purple" block>{{$t('save')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
            <span v-if="isGoogleAuth">{{email}}</span>
          </v-expansion-panel-content>
          <v-expansion-panel-content v-if="isGoogleAuth">
            <div slot="header">{{$t('Set password')}}</div>
            <v-form
              class="change-form"
              @submit.prevent="validateForm('set-password')"
              data-vv-scope="set-password"
            >
              <v-container grid-list-lg>
                <v-layout row wrap>
                  <v-flex xs12 sm6>
                    <v-text-field
                      hide-details
                      box
                      class="custom-append add-margin"
                      color="purple"
                      ref="setPassword"
                      name="setPassword"
                      :label="$t('Set password')"
                      data-vv-name="setPassword"
                      data-vv-delay="300"
                      min="8"
                      v-validate="'required|min:8'"
                      :placeholder="$t('Set your password')"
                      v-model="setPassword"
                      :error-messages="errors.collect('password')"
                      :type="isPasswordVisible3 ? 'text' : 'password'"
                    >
                      <template slot="append">
                        <div @click="changeVal('isPasswordVisible3')">
                          <span v-if="!isPasswordVisible3">{{$t('Show')}}</span>
                          <span v-else>{{$t('Hide')}}</span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-text-field
                      box
                      class="custom-append add-margin"
                      color="purple"
                      :label="$t('CONFIRM PASSWORD')"
                      data-vv-name="password_confirmation2"
                      data-vv-delay="300"
                      target="setPassword"
                      v-validate="'required|confirmed:setPassword'"
                      :placeholder="$t('Enter confirm password')"
                      v-model="password_confirmation2"
                      :error-messages="errors.collect('password_confirmation')"
                      :type="isPasswordVisible4 ? 'text' : 'password'"
                    >
                      <template slot="append">
                        <div @click="changeVal('isPasswordVisible4')">
                          <span v-if="!isPasswordVisible4">{{$t('Show')}}</span>
                          <span v-else>{{$t('Hide')}}</span>
                        </div>
                      </template>
                    </v-text-field>
                  </v-flex>
                  <v-flex xs6 sm3>
                    <v-btn class="add-margin" type="submit" dark color="purple" block>{{$t('save')}}</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- <v-expansion-panel v-model="panel">
                <v-expansion-panel-content v-for="(item,i) in 3" :key="i">
                    <div slot="header">Item
                    {{panel === i}}
                    </div>
                    <v-card>
                        <v-card-text>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</v-card-text>
                    </v-card>
                </v-expansion-panel-content>
        </v-expansion-panel>-->
      </v-card-text>
    </v-card>
    <v-dialog v-model="errorDialog" max-width="350" class="error-dialog">
      <v-card>
        <v-card-title class="text-xs-center justify-center">{{errorMsg}}</v-card-title>
        <v-card-actions v-if="successRegister">
          <v-btn dark color="purple" @click="successRegistered">{{errorBtn}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <cropper
      :src="newLogo"
      :viewMode="3"
      :responsive="true"
      :aspectRatio="1/1"
      :show="false"
      @croped="cropImage"
    />
  </v-flex>
  <!-- <UploadFile></UploadFile> -->
</template>
<script>
import Vue from "vue";
import VeeValidate from "vee-validate";
import axios from "axios";
import cropper from "@/components/cropper.vue";
// import cropper from "vue-cropper-image";

// import logo from './../assets/default-user-image-female.png';
// import UploadFile from '@/components/UploadFile.vue'

Vue.use(VeeValidate);

export default {
  name: "UserView",

  components: {
    cropper
  },

  $_veeValidate: {
    validator: "new"
  },

  data: () => ({
    valid: true,
    change: true,
    changeLogo: false,
    firstName: "Firstname",
    lastName: "Lastname",
    email: "template@mail.com",
    logo: "img/icons/default-user-image-female.png",
    logoLink: "",
    newLogo: "",
    newFirstName: "",
    newLastName: "",
    newEmail: "",
    panel: null,
    selectedLanguage: "",
    langList: [],
    isPasswordVisible: false,
    isPasswordVisible2: false,
    isPasswordVisible3: false,
    isPasswordVisible4: false,
    password: "",
    emailPass: "",
    newPassword: "",
    passwordCurrent: "",
    password_confirmation: "",
    password_confirmation2: "",
    setPassword: "",
    successRegister: false,
    isGoogleAuth: false,
    errorBtn: "ok",
    errorDialog: false,
    errorMsg: "IDK why do u see this window",
    dictionary: {
      custom: {
        firstName: {
          required: () => Vue.i18n.translate("First Name can not be empty"),
          max: Vue.i18n.translate(
            "The first name field may not be greater than {amount} characters",
            { amount: 10 }
          )
        },
        lastName: {
          required: () => Vue.i18n.translate("Last Name can not be empty")
        },
        email: {
          required: () => Vue.i18n.translate("Email can not be empty"),
          email: Vue.i18n.translate("Invalid email")
        },
        password: {
          required: () => Vue.i18n.translate("Password can not be empty"),
          min: Vue.i18n.translate(
            "The password field may not be lesser than {amount} characters",
            { amount: 8 }
          )
        },
        password_confirmation: {
          required: () =>
            Vue.i18n.translate("Password confirmation can not be empty"),
          confirmed: Vue.i18n.translate(
            "The password confirmation does not match"
          )
        }
      }
    }
  }),

  created() {
    this.init();
    this.selectedLanguage = this.$store.getters.getCurrentLanguage;
    this.langList = this.$store.getters.getLangList;
  },

  mounted() {
    this.$validator.localize("uk", this.dictionary);
  },

  methods: {
    encodeImageFileAsURL(element) {
      let reader = new FileReader();
      reader.readAsDataURL(element);
      reader.onloadend = () => {
        this.newLogo = reader.result;
        console.log(reader.result);
      };
    },

    validateForm(scope) {
      this.$validator.validateAll(scope).then(result => {
        console.log(scope, result);
        if (result) {
          if (scope == "edit-name") {
            console.log("edit-name");
            axios
              .post(
                this.$hostname + "/client/changenames/",
                {
                  first_name: this.newFirstName,
                  last_name: this.newLastName
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("token")
                  }
                }
              )
              .then(response => {
                if (response.status === 200) {
                  console.log(response);
                  this.init();
                  this.errorDialog = true;
                  this.errorMsg = this.$t("Successfully changed");
                }
              })
              .catch(error => {
                this.errorDialog = true;
                this.errorMsg = `${this.$t(
                  this.$store.getters.errorsList[error.response.data.message]
                )}`;
              });
          } else if (scope == "edit-email") {
            console.log("mail");
            axios
              .post(
                this.$hostname + "/client/changeemail/",
                {
                  new_email: this.newEmail,
                  password: this.emailPass
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("token")
                  }
                }
              )
              .then(response => {
                console.log(response);
                if (response.status === 200) {
                  localStorage.setItem("token", response.data.data.token);
                  this.errorDialog = true;
                  this.errorMsg = this.$t("Successfully changed");
                  this.errorBtn = this.$t("ok");
                  this.init();
                }
              })
              .catch(error => {
                this.errorDialog = true;
                this.errorMsg = `${this.$t(
                  this.$store.getters.errorsList[error.response.data.message]
                )}`;
              });
          } else if (scope == "edit-password") {
            console.log("edit-password");
            axios
              .post(
                this.$hostname + "/client/changepassword/",
                {
                  new_password: this.newPassword,
                  password: this.passwordCurrent
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("token")
                  }
                }
              )
              .then(response => {
                console.log(response);
                if (response.status === 200) {
                  localStorage.setItem("token", response.data.data.token);
                  this.errorDialog = true;
                  this.errorMsg = this.$t("Successfully changed");
                  this.errorBtn = this.$t("ok");
                  this.init();
                }
              })
              .catch(error => {
                this.errorDialog = true;
                this.errorMsg = `${this.$t(
                  this.$store.getters.errorsList[error.response.data.message]
                )}`;
              });
          } else if (scope == "set-password") {
            console.log("set-password");
            axios
              .post(
                this.$hostname + "/client/setpassword/",
                {
                  password: this.setPassword
                },
                {
                  headers: {
                    Authorization: localStorage.getItem("token")
                  }
                }
              )
              .then(response => {
                console.log(response);
                localStorage.setItem("token", response.data.data.token);
                this.init();
              })
              .catch(error => {
                this.errorDialog = true;
                this.errorMsg = `${this.$t(
                  this.$store.getters.errorsList[error.response.data.message]
                )}`;
              });
          }
        } else {
          if (scope == "edit-name") {
            if (!this.newFirstName.length || !this.newLastName) {
              this.errorDialog = true;
              this.errorMsg = this.$t("First or Last Name cannot be empty");
            }
          } else if (scope == "edit-email") {
            if (this.emailPass.length < 8) {
              this.errorDialog = true;
              this.errorMsg = this.$t(
                "The password field may not be lesser than {amount} characters",
                { amount: 8 }
              );
            } else if (!this.newEmail) {
              this.errorDialog = true;
              this.errorMsg = this.$("Email input not valid or empty");
            }
          } else if (scope == "edit-password") {
            if (
              this.newPassword.length < 8 ||
              this.passwordCurrent.length < 8
            ) {
              this.errorDialog = true;
              this.errorMsg = this.$t(
                "The password field may not be lesser than {amount} characters",
                { amount: 8 }
              );
            }
          } else if (scope == "set-password") {
            if (this.setPassword.length < 8) {
              this.errorDialog = true;
              this.errorMsg = this.$t(
                "The password field may not be lesser than {amount} characters",
                { amount: 8 }
              );
            } else {
              this.errorDialog = true;
              this.errorMsg = this.$t("Confirm Your Password");
            }
          }
        }
      });
    },

    mouseOver() {
      this.changeLogo = true;
    },

    mouseLeave() {
      this.changeLogo = false;
    },

    changeVal(value) {
      this[value] = !this[value];
    },

    logout() {
      localStorage.setItem("currentLang", "en")
      Vue.i18n.set("en")
      localStorage.removeItem("token");
      this.$router.push("/");
    },

    updateImg() {
      let element = this.$refs.fileInput;
      this.encodeImageFileAsURL(element.files[0]);
      // let formData = new FormData();
      // formData.append("file", event.target.files[0]);
      // this.uploadedLogo = event.target.files[0];
      // axios
      //   .post("https://web.purepurr.tech/file/image/upload/11", formData)
      //   .then(response => {
      //     console.log(response);
      //   });
    },

    cropImage(event) {
      // this.logo = event.toDataURL();
      let imageURL = event.toDataURL();
      console.log(imageURL);
      axios
        .post(
          "https://web.purepurr.tech/file/image/upload",
          {
            image: imageURL
          },
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          console.log(response);
          this.init();
        });
      // block = imageURL.split(";"),
      // contentType = block[0].split(":")[1],
      // realData = block[1].split(",")[1],
      // blob = this.b64toBlob(realData, contentType),
      // formData = new FormData();
      // formData.append("file", blob);
      // axios
      //   .post(
      //     "https://web.purepurr.tech/file/image/upload/" + this.logoId,
      //     formData
      //   )
      //   .then(response => {
      //     console.log(response);
      //     this.init();
      //   });
    },

    init() {
      let token = localStorage.getItem("token");
      this.isGoogleAuth = false;
      if (!token) {
        console.log("token empty");
        this.$router.push("/");
      } else {
        if (token.startsWith("Google")) {
          this.isGoogleAuth = true;
          console.log("Google");
        }
        axios
          .get(this.$hostname + "/client/me/", {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          })
          .then(response => {
            console.log(response);
            this.firstName = this.newFirstName = response.data.data.first_name;
            this.lastName = this.newLastName = response.data.data.last_name;
            this.email = this.newEmail = response.data.data.email;
            this.logoLink = response.data.data.image;
            if (this.isGoogleAuth || !response.data.data.image === "null") {
              this.logo = response.data.data.image;
            }
            return axios.get("https://web.purepurr.tech/file/image/download", {
              headers: {
                Authorization: localStorage.getItem("token")
              }
            });
          })
          .then(response => {
            console.log(response);
            this.logo = response.data.data.image;
          });
      }
    },

    reset() {
      axios
        .post(
          this.$hostname + "/reset",
          {
            email: this.email
          },
          {
            headers: {
              Authorization: localStorage.getItem("token")
            }
          }
        )
        .then(response => {
          console.log(response);
        })
        .catch(error => {
          this.errorDialog = true;
          this.errorMsg = `${this.$t(
            this.$store.getters.errorsList[error.response.data.message]
          )}`;
        });
      this.errorDialog = true;
      this.errorMsg = this.$t(
        "We send you an email with instructions on how to reset your password."
      );
    },

    changeLang(lang) {
      localStorage.setItem("currentLang", lang)
      this.$store.commit("setLanguage", lang)
      // Vue.i18n.set(lang)
      location.reload();
    },

    successRegistered() {
      this.$router.push("/");
    }
  },

  computed: {
    getCurrentLang(){
      return localStorage.getItem("currentLang")
    }
  },
};
</script>

<style scoped lang="scss">
.v-card.card-wrapper {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  padding-top: 20px;
  min-height: 350px;

  & .v-icon {
    font-size: 20px;
    z-index: 9;
    cursor: pointer;
  }

  & > .v-card__text {
    position: relative;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .v-avatar {
      .v-icon {
        position: absolute;
        background-color: rgba(0, 0, 0, 0.5);
        color: purple;
      }

      img {
        border: 3px solid #800057;
      }
    }

    .title {
      margin-top: 15px;
      font-size: 19px !important;
      margin-bottom: 5px;
    }

    .subheading {
      font-size: 15px;
      opacity: 0.5;
    }
  }

  @media (max-width: 960px) {
    border-top-right-radius: 5px;
    border-bottom-left-radius: 0;
  }
}

.change-form {
  .container {
    padding-left: 0;
    padding-right: 0;
    .flex {
      padding-bottom: 0;
      padding-top: 0;
    }
  }
}

@media (max-width: 600px) {
  .add-margin {
    margin-bottom: 15px;
  }
}
</style>
